import LayoutActividad from "../../../components/LayoutActividad";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { modulo13 } from "../../../routes/Module13";
import Sidebar from "../Sidebar";
import { faComments } from "@fortawesome/free-solid-svg-icons";
import Imagen1 from "../../../images/modulo13/casalluvia.png";
import Imagen2 from "../../../images/modulo13/casasol.png";
import Imagen3 from "../../../images/modulo13/casaselva.png";
import Imagen4 from "../../../images/modulo13/casalima.png";

import GuiaDocente from "../../../components/GuiaDocente";
import AudioPlayer from "../../../audioPlayer/AudioPlayer";
import Audio from "../../../audios/modulo13/Unidad1Actividad6.mp3";

const Actividad9 = () => {
  const infoUnidad = modulo13.content[0];
  const infoAct = modulo13.content[0].activities[7];
  const crumbs = [
    {
      title: modulo13.title,
      url: "/" + modulo13.url,
    },
    {
      title:
        modulo13.content.length === 1
          ? `${infoAct.name}`
          : `${infoUnidad.name} > ${infoAct.name}`,
      url: infoAct.path,
    },
  ];

  const pages = {
    titleNext: `${modulo13.content[0].name}: ${modulo13.content[0].activities[8].name}`,
    linkNext: `${modulo13.url}/${modulo13.content[0].path}/${modulo13.content[0].activities[8].path}`,
    titlePrev: `${modulo13.content[0].name}: ${modulo13.content[0].activities[6].name}`,
    linkPrev: `${modulo13.url}/${modulo13.content[0].path}/${modulo13.content[0].activities[6].path}`,
  };
  const metadata = {
    color: modulo13.color,
    title: `${modulo13.title} - ${infoAct.name}`,
    name: modulo13.title,
  };

  return (
    <LayoutActividad
      pages={pages}
      crumbs={crumbs}
      sidebar={<Sidebar />}
      modulo={metadata}
    >
      <p>
        <small className={`c-${modulo13.color} hat-text`}>
          <FontAwesomeIcon icon={faComments} /> Dialogamos
        </small>
      </p>

      <h2 className="mb-5">{infoAct.name}</h2>
          <AudioPlayer track={Audio} />
      <ul>
        <li>Observa las siguientes imágenes:</li>
      </ul>
      <img src={Imagen1} className="img-fluid" alt="Peruanos" />
      <img src={Imagen2} className="img-fluid" alt="Peruanos" />
      <img src={Imagen3} className="img-fluid" alt="Peruanos" />
      <img src={Imagen4} className="img-fluid" alt="Peruanos" />

      <div className="row mt-4">
        <div className="col-lg-10 col-12 p-0">
          <ul>
            <li>
              Conversa con un compañero, compañera o familiar. ¿Por qué crees
              que las casas son distintas en cada región? ¿Crees que se han
              construido pensando en el entorno de cada zona?
            </li>
          </ul>
          <textarea className="form-control" rows={3} />
        </div>
      </div>

      <GuiaDocente>
        <ul>
          <li>
            Explique que las siguientes actividades buscan conversar acerca del
            impacto que tienen las transformaciones que hace el ser humano sobre
            el territorio.
          </li>
          <li>
            Lea la primera indicación: Observa las siguientes imágenes. Pida que
            observen las imágenes propuestas y que en silencio respondan: “¿Qué
            ven en cada una de las imágenes? ¿Son las casas iguales? ¿Es el
            entorno parecido?”
          </li>
          <li>
            Lea la segunda indicación: Conversa con un(a) compañero(a). ¿Por qué
            crees que las casas son distintas en cada región? ¿Crees que se han
            construido pensando en el entorno de cada zona? Explique que deben
            de trabajar en parejas o con un familiar y discutir sobre las preguntas dadas. Ahora
            retome algunas respuestas de sus alumnos en cada una de las imágenes
            presentadas. Por ejemplo:
            <ul>
              <li>
                <i>
                  “¿Qué vemos en la primera imagen? (Posible respuesta: Es una
                  casa de adobe, con techo de tejas. Las ventanas son pequeñas).
                </i>
              </li>
              <li>
                <i>
                  ¿Y en la segunda imagen? (Posible respuesta: Vemos una casa
                  hecha de caña con barro, rodeada de algarrobos).
                </i>
              </li>
              <li>
                <i>
                  ¿Y en la última imagen? (Posible respuesta: Observamos una
                  “maloca”, una casa que parece de madera y paja que está sobre
                  palafitos).
                </i>
              </li>
              <li>
                <i>
                  ¿En qué regiones podríamos encontrar estas casas? (Posible
                  respuesta: La primera podríamos encontrarla en la sierra; la
                  segunda imagen corresponde a una casa en la costa; y la
                  tercera imagen, a una casa en la selva).
                </i>
              </li>
              <li>
                <i>
                  ¿Por qué las casas son distintas en cada región? (Posible
                  respuesta: Porque se tienen que adaptar al entorno en el que
                  están).
                </i>
              </li>
              <li>
                <i>
                  ¿Por qué se construyen pensando en el entorno? (Posible
                  respuesta: Porque, de lo contrario, las casas tendrían muchos
                  problemas; por ejemplo, no se puede vivir en una maloca en la
                  sierra porque se tendría mucho frío)”.
                </i>
              </li>
            </ul>
          </li>

          <li>
            Cierre la actividad resaltando la importancia de adaptarse al
            entorno de cada zona. Para ello, mencione que cada entorno presenta
            características muy particulares, por lo que es importante pensar en
            el clima, el relieve y los recursos de cada lugar.
          </li>
        </ul>
      </GuiaDocente>
    </LayoutActividad>
  );
};

export default Actividad9;
